import { QueryClient } from "@tanstack/react-query";

export const CUSTOMER_DETAILS_QUERY_KEY = "customer-details";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            gcTime: 1000 * 60 * 60,
        },
    },
});

export const clearCustomerDetailsQueries = (): void => {
    queryClient.removeQueries({ queryKey: [CUSTOMER_DETAILS_QUERY_KEY], exact: false });
};
